import { render } from "./profile.vue?vue&type=template&id=0c1170a8&ts=true"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"

import "./profile.vue?vue&type=style&index=0&id=0c1170a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__